export const filterOptions = {
  DISEASES: [
    { value: 'diseaseUMLSCUI', label: 'Disease CUI' },
    { value: 'diseaseName', label: 'Disease Name' },
    { value: 'MSH', label: 'MESH' },
    { value: 'OMIM', label: 'OMIM' },
    { value: 'NCI', label: 'NCI' },
    { value: 'HPO', label: 'HPO' },
    { value: 'MONDO', label: 'MONDO' },
  ],
  VARIANTS: [
    { value: 'strID', label: 'VARIANT rs number' },
    { value: 'chromocoord', label: 'Chrom. position' },
  ],
  GENES: [
    { value: 'symbol', label: 'Gene symbol' },
    { value: 'ensemblID', label: 'Ensembl ID' },
    { value: 'uniprotID', label: 'Uniprot ID' },
    { value: 'geneID', label: 'Gene ID' },
  ],
  CHEMICALS: [
    { value: 'CHEMBL', label: 'Chembl ID' },
    { value: 'CHEBI', label: 'Chebi ID' },
    { value: 'DRUGBANK', label: 'Drugbank ID' },
    { value: 'MESH', label: 'MESH' },
    { value: 'PUBCHEM', label: 'Pubchem ID' },
  ],
};

export const renderFilterOptions = (searchType, selectedFilter, setSelectedFilter) => {
  const currentFilters = filterOptions[searchType] || [];

  return (
    <select
      name="filter"
      value={selectedFilter}
      onChange={e => setSelectedFilter(e.target.value)}
      className="custom-dropdown"
    >
      {currentFilters.map(filter => (
        <option key={filter.value} value={filter.value}>
          {filter.label}
        </option>
      ))}
    </select>
  );
};

export const getExpectedFormatMessage = (searchType, selectedFilter) => {
  if (searchType === 'DISEASES') {
    if (selectedFilter === 'diseaseUMLSCUI') {
      return 'CUIs are: C0002736, C1862939, C2677565';
    } else if (selectedFilter === 'MSH') {
      return 'MESH are: D014211, D003922, D003923';
    } else if (selectedFilter === 'OMIM') {
      return 'OMIM are: 147450, 612069, 602432';
    } else if (selectedFilter === 'NCI') {
      return 'NCI are: C34373, C34558, C131626';
    } else if (selectedFilter === 'HPO') {
      return 'HPO are: HP:0009031, HP:0001250, 0004322';
    } else if (selectedFilter === 'MONDO') {
      return 'MONDO are: 0005335, 0008315, 0004950';
    } else if (selectedFilter === 'diseaseName') {
      return 'Name are: Alopecia, Hypertension, Kyphosis';
    }
    // return selectedFilter === 'name'
    //   ? "Name is: Alzheimer's Disease"
    //   : 'CUIs are: C0002736, C1862939, C2677565';
  }
  if (searchType === 'VARIANTS') {
    if (selectedFilter === 'strID') {
      return 'rs numbers are: rs75290158, rs142200609, rs893051';
    } else if (selectedFilter === 'chromocoord') {
      return 'position are: 1:11796321, 6:31575254, 7:140753336';
    }
  }

  if (searchType === 'GENES') {
    if (selectedFilter === 'symbol') {
      return 'Symbols are: BRCA1, TP53, EGFR';
    } else if (selectedFilter === 'ensemblID') {
      return 'Ensemb IDs are: ENSG00000141510, ENSG00000134982, ENSG00000157764';
    } else if (selectedFilter === 'uniprotID') {
      return 'Uniprot IDs are: P04637, Q9BYF1, P38398';
    } else if (selectedFilter === 'geneID') {
      return 'IDs are: 672, 7157, 1956';
    }
  }

  if (searchType === 'CHEMICALS') {
    if (selectedFilter === 'CHEBI') {
      return 'ChEBI IDs are: 16236, 18258, 18243';
    } else if (selectedFilter === 'DRUGBANK') {
      return 'DrugBank IDs are: DB00002, DB00898, DB00997';
    } else if (selectedFilter === 'MESH') {
      return 'MeSH are: D002945, D000431, D004317';
    } else if (selectedFilter === 'CHEMBL') {
      return 'ChEMBL IDs are: CHEMBL1251, CHEMBL4382, CHEMBL357328';
    } else if (selectedFilter === 'PUBCHEM') {
      return 'PubChem IDs are: 702, 2244, 60961';
    }
  }
  return '';
};

export const getMsg = (searchType, selectedFilter) => {
  const messages = {
    DISEASES: {
      diseaseUMLSCUI: 'CUI',
      MSH: 'MESH',
    },
    VARIANTS: {
      strID: 'rs number',
    },
    GENES: {
      symbol: 'Symbol',
    },
    CHEMICALS: {
      CHEMBL: 'CUI', // todo: fix this?
    },
  };

  return messages[searchType]?.[selectedFilter] || '';
};

export const getItemCount = text => text.split('\n').filter(line => line.trim() !== '').length;

export const validateInput = (input, searchType, selectedFilter) => {
  if (searchType === 'DISEASES') {
    if (selectedFilter === 'diseaseUMLSCUI') {
      const cuiRegex = /^[A-Za-z0-9]{7,8}$/;
      return cuiRegex.test(input);
    }
    if (selectedFilter === 'diseaseName') {
      const dnRegex = /^.*$/i;
      return dnRegex.test(input);
    }
    if (selectedFilter === 'MSH') {
      const cuiRegex = /^[A-Za-z0-9]{7,8}$/;
      return cuiRegex.test(input);
    }
    if (selectedFilter === 'name') {
      const nameRegex = /^[A-Za-z0-9\s\-'.,]+$/;
      return nameRegex.test(input) && !/^C\d+$/.test(input);
    }
    if (selectedFilter === 'OMIM') {
      const omimRegex = /^\d{5,6}$/;
      return omimRegex.test(input);
    }

    if (selectedFilter === 'NCI') {
      const nciRegex = /^C\d{5,6}$/;
      return nciRegex.test(input);
    }

    if (selectedFilter === 'EFO') {
      const efoRegex = /^\d{7}$/;
      return efoRegex.test(input);
    }

    if (selectedFilter === 'DO') {
      const doRegex = /^\d{7}$/;
      return doRegex.test(input);
    }

    if (selectedFilter === 'ORDO') {
      const ordoRegex = /^\d{3}$/;
      return ordoRegex.test(input);
    }

    if (selectedFilter === 'HPO') {
      const hpoRegex = /^HP:\d{7}$/;
      return hpoRegex.test(input);
    }

    if (selectedFilter === 'MONDO') {
      const mondoRegex = /^\d{7}$/;
      return mondoRegex.test(input);
    }
  }
  if (searchType === 'VARIANTS') {
    if (selectedFilter === 'strID') {
      const rsidRegex = /^.*$/i;
      return rsidRegex.test(input);
    }
    if (selectedFilter === 'chromocoord') {
      const chrRegex = /^\d+:\d+$/;
      return chrRegex.test(input);
    }
    // if (selectedFilter === 'geneSymbol') {
    //   const geneSymbolRegex = /^[A-Za-z0-9_-]+$/;
    //   return geneSymbolRegex.test(input);
    // }
  }
  if (searchType === 'GENES') {
    if (selectedFilter === 'symbol' || selectedFilter === 'geneSymbol') {
      const geneSymbolRegex = /^[A-Za-z0-9_-]+$/;
      return geneSymbolRegex.test(input);
    }
    if (selectedFilter === 'geneID' || selectedFilter === 'geneId') {
      const geneIDRegex = /^\d+$/;
      return geneIDRegex.test(input);
    }
    if (selectedFilter === 'ensemblID' || selectedFilter === 'ensemblId') {
      const ensemblIDRegex = /^ENSG\d{11}$/;
      return ensemblIDRegex.test(input);
    }
    if (selectedFilter === 'uniprotID' || selectedFilter === 'uniprotId') {
      const uniprotIDRegex = /^[A-Za-z0-9]{6,10}$/;
      return uniprotIDRegex.test(input);
    }
  }
  if (searchType === 'CHEMICALS') {
    if (selectedFilter === 'chemPrefName') {
      const chemNameRegex = /^[A-Za-z0-9\s\-'.,]+$/;
      return chemNameRegex.test(input) && !/^C\d{7}$/.test(input);
    }
    if (selectedFilter === 'CHEBI') {
      const tmpRegex = /^[0-9]+$/;
      return tmpRegex.test(input);
    }
    if (selectedFilter === 'DRUGBANK') {
      const tmpRegex = /^[A-Za-z0-9_-]+$/;
      //const tmpRegex = /^(DB|db)\d+$/;
      return tmpRegex.test(input);
    }
    if (selectedFilter === 'MESH') {
      const tmpRegex = /^[A-Za-z0-9_-]+$/;
      //const tmpRegex = /^D|d\d+$/;
      return tmpRegex.test(input);
    }
    if (selectedFilter === 'CHEMBL') {
      const tmpRegex = /^[A-Za-z0-9_-]+$/;
      //const tmpRegex = /^CHEMBL\d+$/;
      return tmpRegex.test(input);
    }
    if (selectedFilter === 'PUBCHEM') {
      const tmpRegex = /^[0-9]+$/;
      return tmpRegex.test(input);
    }
  }
  return false;
};
